const { List } = require('immutable');
const { resolveResource } = require('./resolve');
const createSelector = require('./createSelector');
const cacheSelector = require('./cacheSelector');
const resourceSelector = require('./resourceSelector');
const programListAll = (state) => resourceSelector(state, { type:'program_lists', id:'programs_all' });
const programListSelector = createSelector(
	[cacheSelector, programListAll],
	(cache, resource) => resolveResource(resource, cache, [])
		.get('programs', List())
);

module.exports = programListSelector;



/** WEBPACK FOOTER **
 ** ./app/selectors/programListSelector.js
 **/